export const m = {
    common: {
        weekList: [
            "星期日",
            "星期一",
            "星期二",
            "星期三",
            "星期四",
            "星期五",
            "星期六",
        ],
        errorTitle: '请输入手机号或验证码',
        queryCity: '支持输入城市名查询',
        bindPhones: '请先绑定手机号',
        homePage: "首页",
        shService: '售后服务',
        sqService: '申请售后',
        shdDetail: '售后单详情',
        edDetail: '额度使用明细',
        warnMsg: '您已预约体检，请在体检订单中查看',
        zhAq: '账户安全',
        yuYue: '填写预约信息',
        ygDetail: '员工体检-套餐详情',
        ygBranchDetail: '员工体检-分院详情',
        orderCheck: '订单确认',
        yuYueStatusOk: '预约中',
        yuYueStatusFailed: '预约失败',
        yuYueStatusSuccess: '预约成功',
        orderModelDetail: '体检订单详情',
        uploadMsg: '您不仅可以上传体检报告，也可以上传化验单等其它形式的体检信息，我们的医生都会为您进行专业的解读服务。',
        txYw: '请先填写您的疑问',
        dontSaveTxt: '您填写的疑问不能低于20个字符',
        updateFile: '请上传相同类型文件上传',
        CancelSuccess: '取消成功',
        ConfirmCancellation: '确认取消预约?',
        deleteReport: '确认删除该体检报告?',
        zhankia: '展开',
        shouqi: '收起',
        prompt: "温馨提示",
        limit: '您的剩余额度:',
        cancellation: '本次额度未使用即作废，是否确认进行下一步？',
        affirm: '确认，下一步',
        continue: '继续选择',
        phoneNum: '400-068-5099 转 1 转 5566',
        load: '加载中,请稍后...',
        welcome: '欢迎',
        password: '员工登录',
        certificate: '请输入证件号',
        inputPassword: '请输入密码',
        pwdRules: '密码不得少于6位，至少包含字母、数字、符号2种及以上组合',
        register: '登录',
        verification: '验证码登录',
        code: '获取验证码',
        mobile: '请输入手机号',
        importVerification: '请输入验证码',
        checkstand: '收银台',
        order: '我的订单',
        cart: '我的购物车',
        quit: '退出登录',
        homePage: '体检活动须知',
        tjService: '体检服务',
        jkmall: '健康优选',
        my: '个人中心',
        healthLife: '健康生活',
        healthCheck: '健康体检',
        healthInsurancePlan: '健康保障计划',
        footerTest: '©2017-2021 乐荐信息科技（北京）有限公司版权所有',
        define: '确定',
        submit: '提交',
        noHave: '无',
        cancelBtn: '取消',
        edit: '编辑',
        getDetail: '查看详情',
        self: '本人',
        depend: '家属',
        total: '总价',
        man: '男',
        woman: '女',
        yes: '是',
        nay: '否',
        dont: '不',
        unbound: '未绑定',
        nationalType: {
            idcard: '身份证',
            passport: '护照',
            gat: '港澳台通行证',
            other: '其他'
        },
        relation: {
            parent: '父母',
            mate: '配偶'
        },
        goBack: '返回上一页',
        editMessage: '编辑信息',
        surplusAmounts: '总剩余额度',
        isQuit: '是否退出登录？',
        quitSuccess: '退出成功',
        okAppointment: '确认并预约',
        risk: '是否需要提供体检后疾病风险评估预测',
        risks: '需要提供体检后疾病风险评估预测',
        nayHos: '暂无可约机构',
        closeBtn: '关闭',
        disAgree: '不同意',
        agree: '同意',
        revisePhone: '修改手机号',
        treaty: '请先阅读用户协议及隐私政策',
        noGet: '不在本平台查询体检报告',
        agreeGet: '已阅读，同意授权',
        principal: '元',
        pleaseChoose: '请选择',
        reminder: '温馨提示',
        clash: '放射项目过多（颈椎、腰椎），不建议同时选择！'
    },
    afterMarket: {
        index: {
            title: '售后列表',
            addAfterMarket: '发起售后申请',
            reasonTit: '申请原因',
            statusTit: '售后状态',
            handleTit: '操作',
            creatTime: '创建时间',
            workNo: '单号',
            getDetail: '查看详情',
            closeTit: '关闭售后',
            isClose: '确认关闭该售后单?',
            closeSuccessTxt: '关闭成功'
        },
        detail: {
            title: '售后详情',
            record: '申请记录',
            phone: '联系电话',
            reason: '申请原因',
            imgDec: '图片描述',
            textDec: '文字描述',
            dispose: '处理记录',
            price: '退款金额',
            remark: '处理备注',
            not: '暂无',
        },
        edit: {
            inputPhone: '请输入联系电话',
            inputSuccessPhone: '请输入正确的联系电话',
            inputReason: '请选择申请原因',
            inputImgDec: '请上传图片描述',
            inputTextDec: '请输入文字描述',
            textNum: '文字描述不得低于十个字符',
            keep: '保存修改',
            remove: '删除成功',
            num: '最多上传三张',
            editSuccess: '修改成功'
        },
        applyFor: {
            title: '申请售后',
            success: '提交成功',
            submit: '提交'
        }
    },
    login: {
        passwordLogin: '密码登录',
        userPlaceholder: '请输入证件号',
        passwordPlaceholder: '请输入密码',
        register: '登录',
        qhcodeLogin: '验证码登录',
        phonePlaceholder: '请输入手机号',
        codePlaceholder: '请输入验证码',
        getcode: '获取验证码',
        forgotPass: '找回密码',
        backLogin: '返回登录',
        backTit: '使用手机号找回密码',
        next: '下一步',
        resetPass: '重置密码',
        passwordPrompt: '默认密码为证件号后六位遇X前移，X为大写。',
        haveRead: '我已阅读并同意',
        userAgreement: '《用户协议》',
        and: '及',
        privacyPolicy: '《隐私政策》',
        loginQue: '如遇登录问题',
        clickHere: '点击此处',
        getInto: '进入HR值班号',
        upgrade: '提高健康状况和职场生活质量'
    },
    index: {
        brankNav: '体检服务> ',
        brankNav2: '体检 > 体检服务手册',
        welcomeTit: '2020年字节跳动体检活动须知',
        subscribe: '跳过，直接预约体检',
        msgArr: ['1. 定期健康体检是预防保健，早期发现疾病、亚健康的重要手段，为了保持健康，对疾病能做到早期诊断，及时治疗，应该定期到进行健康检查。这样可以及时了解身体内部的情况，可以及时发现一些重要的疾病，同时可以全面估计自己的健康状况，听取医生的意见和建议，用以指导自己的生活保健。', ' 2. 定期健康体检是预防保健，早期发现疾病、亚健康的重要手段，为了保持健康，对疾病能做到早期诊断，及时治疗，应该定期到进行健康检查。这样可以及时了解身体内部的情况，可以及时发现一些重要的疾病，同时可以全面估计自己的健康状况，听取医生的意见和建议，用以指导自己的生活保健。', '3. 定期健康体检是预防保健，早期发现疾病、亚健康的重要手段，为了保持健康，对疾病能做到早期诊断，及时治疗，应该定期到进行健康检查。这样可以及时了解身体内部的情况，可以及时发现一些重要的疾病，同时可以全面估计自己的健康状况，听取医生的意见和建议，用以指导自己的生活保健。定期健康体检是预防保健，早期发现疾病、亚健康的重要手段，为了保持健康，对疾病能做到早期诊断，及时治疗，应该定期到进行健康检查。这样可以及时了解身体内部的情况，可以及时发现一些重要的疾病，同时可以全面估计自己的健康状况，听取医生的意见和建议，用以指导自己的生活保健。', ' 4. 定期健康体检是预防保健，早期发现疾病、亚健康的重要手段，为了保持健康，对疾病能做到早期诊断，及时治疗，应该定期到进行健康检查。这样可以及时了解身体内部的情况，可以及时发现一些重要的疾病，同时可以全面估计自己的健康状况，听取医生的意见和建议，用以指导自己的生活保健。', ' 5. 定期健康体检是预防保健，早期发现疾病、亚健康的重要手段，为了保持健康，对疾病能做到早期诊断，及时治疗，应该定期到进行健康检查。这样可以及时了解身体内部的情况，可以及时发现一些重要的疾病，同时可以全面估计自己的健康状况，听取医生的意见和建议，用以指导自己的生活保健。'],
        tsMsg: '体检采用预约制，未预约直接前往可能无法正常体检',
        wrisubscribe: '已阅读，开始预约体检',
        beforePhysicalExamination: '体检前',
        beforePhysicalExaminationP1: '提前1-2周预约体检',
        beforePhysicalExaminationP2: '登录体检平台或电话预约',
        beforePhysicalExaminationP3: '可自费加项或为家属购买',
        physicalExamination: '体检日',
        physicalExaminationP1: '当天8:00-10:00到场',
        physicalExaminationP2: '空腹，带齐证件',
        physicalExaminationP3: '临时取消可致电客服改签',
        afterPhysicalExamination: '体检后',
        afterPhysicalExaminationP1: '尽快完成满意度调研',
        afterPhysicalExaminationP2: '5-7个工作日后在平台查收报告',
        afterPhysicalExaminationP3: '参加体检报告解读',
    },
    phyIndex: {
        staffPhyModel: '本人体检',
        dependPhyModel: '家属体检',
        orderModel: '体检订单',
        medicalReportsModel: '体检报告',
        onlineConsultingModel: '在线咨询',
        suggestionModel: '投诉建议',
        phyTit: '健康体检的重要性',
        phyMsg: '定期健康体检是预防保健，早期发现疾病、亚健康的重要手段，为了保持健康，对疾病能做到早期诊断，及时治疗，应该定期到进行健康检查。',
        chooseProjectTit: '选择体检项目',
        errorChoose: '请先选择项目'
    },
    onlineConsulting: {
        brankNav: '体检服务> 在线咨询',
        submit: '在线咨询',
        or: '或',
        phone: '客服电话'
    },
    suggestions: {
        brankNav: '体检服务> 投诉建议',
        suType: '请选择反馈类型',
        suMsg: '请填写反馈信息',
        suPhone: '请填写联系方式',
        radioTJ: '体检服务',
        radioPT: '平台使用',
        suMsgPlaceholder: '您的反馈将帮助我们更快成长',
        suPhonePlaceholder: '手机号、QQ号或邮箱地址',
        success: '反馈成功'
    },
    phyOrderList: {
        refund: '您的体检服务已取消，支付金额将在7个工日内原路退回',
        brankNav: '个人中心 > 体检订单',
        orderNavList: ['全部订单', '待支付', '待体检', '已到检'],
        titList: {
            orderDetail: '订单详情',
            username: '体检人',
            price: '金额',
            status: '全部状态',
            handle: '操作'
        },
        orderItem: {
            orderTime: '下单时间',
            orderNum: '订单号',
            hospital: '体检分院',
            appointment: '体检时间',
            getDetail: '查看详情',
            payMoney: '支付金额',
            payCountdown: '支付倒计时',
            immediateAppointment: '立即预约',
            degree: '满意度调查',
            reAppointment: '重新预约',
            appointmentRescheduling: '预约改期',
            appointmentSuccess: '改期成功',
            immediatePayment: '立即支付',
            cancelOrder: '取消订单',
            chooseTime: '请选择要修改的预约日期',
            apply: '申请售后',
            applyList: '查看售后列表'
        },
        cancelOrderModal: {
            isCancel: '确认取消订单？',
            cancelSuss: '取消订单成功'
        },
        noOrder: '暂无体检订单'
    },
    phyOrderDetails: {
        brankNav: '体检服务> 体检订单 > 订单详情',
        orderStatus: '订单状态',
        cardNum: '证件号',
        phone: '手机号',
        hosTime: '体检机构及时间',
        hospital: '体检机构',
        getHosDetail: '查看机构详情',
        time: '体检日期',
        meal: '体检套餐',
        getMealDetail: '查看套餐详情',
        packages: '专项疾病检测加项包',
    },
    staffMsg: {
        brankNav: '体检服务> ',
        brankNav2: '体检 > 填写预约信息',
        city: '选择体检城市',
        hotCity: '热门城市',
        cityPlaceholder: '请选择城市',
        chooseMeal: '选择体检套餐',
        rightTime: '注：本年度体检周期为',
        mealList: '常规项目',
        exclusivePrice: '专享价',
        choosePackage: '选择专项疾病检测加项包及加项',
        noteFront: '（注：公司付费 "',
        noteAfter: ' " 个定制加项，超出选择的数量须个人付费，定制加项',
        noteAfterTwo: '元/个）',
        packages: '定制加项',
        addition: '自费加项',
        hosTime: '体检机构、分院、时间及套餐',
        hospital: '请选择体检分院',
        hospitals: '体检分院',
        cityMeal: '请先选择城市和机构分类',
        time: '请选择体检日期',
        firstHos: '请先选择机构',
        surplusAmount: '当前剩余信用额度',
        grade: '评分',
        part: '分',
        distance: '距您',
        exe: '*注：妇科检查仅适用于有性生活史且未怀孕女性。',
        brands: '请选择机构分类',
        empowerTit: '用户授权协议',
        forPeople: '适用人群',
        advice: '医学建议',
        leastChooseOne: '至少选择',
        leastChooseTwo: '个定制加项',
        empowerOne: '此用户授权协议（以下简称本协议）由您与乐荐信息科技（北京）有限公司（以下简称乐荐/我们）签订。如您点击选择',
        empowerTwo: '此协议将视为',
        empowerThree: '您授权开通个人体检报告查询功能',
        empowerFour: '，并视为已阅读并理解本协议的全部内容。您不同意本协议的任一内容，请不要进行后续操作。',
        empowerFive: '本协议作为《用户服务协议》的补充协议，在其基础上作补充授权。',
        empowerList: ['1、我们在乐荐云平台（以下简称乐荐平台）向您开通个人用户查询功能须征得您本人（预约人）的授权。', '2、当您在我们购买体检并进行体检预约时，我们会收集您的姓名、性别、证件类型、证件号码、联系方式、婚姻状况信息，并将这些信息提供给您所选择的体检机构，以帮您完成体检预约行为；另外，我们将从上述体检机构获取您的当次体检报告，在您进行体检预约时，我们会征求您的同意。上述信息属于敏感信息，拒绝提供该信息仅会使您无法使用上述功能，但不影响您正常使用我们的其他功能。', ' 3、乐荐平台与各体检机构及医院实现体检数据对接，体检的套餐项目信息、排期信息、预约信息及体检报告数据将通过加密方式实时与体检机构/医院完成信息核实及传递，如经体检机构/医院方的接口返回您已经完成了体检并出具了电子格式的体检报告，您即可通过乐荐平台报告查询入口查阅您的体检报告。', '4、为了您历年的用户信息的完整性，我们会将您查询后的用户信息（含原始数据但不包括乙肝检查结果将保存在云服务器）加密后进行存档，便于您随时查看。', '5、在信息安全方面，我们会对每位用户的信息进行加密，对用户密码采用密文存储；用户信息存储在安全专业的云服务器/数据库中。', ' 6、为了更好地服务，我们将不断完善我们的服务内容，同时也希望您对我们的服务做出监督。至此，我们再次感谢您选择乐荐平台为您提供体检预约和查询服务。'],
        priceDifference: '需自费补差价',
        temporalCue: '疫情期间，预约时间以系统显示为准。',
        companyPay: '你可免费选择',
        staffPay: '个定制加项，超出部分须自行付费（',
        staffPay2: '元/个）',
        writeAddressTit: '填写纸质体检报告邮寄地址',
        writeName: '收件人',
        writeNamePrompt: '请输入收件人姓名',
        writePhone: '联系方式',
        writePhonePrompt: '请输入收件人联系方式',
        writeAddress: '省-市-县-区',
        detailedAddress: '详细地址',
        detailedAddressPrompt: '请输入收件人详细地址',
        isNoChoose: '还未选择免费定制加项，是否确定不选择',
        pleaseChooseAddress: '请选择完整的收货人地址',
        editDialog: {
            tit: '编辑员工信息',
            titPerfect: '补全员工信息',
            name: '姓名',
            sex: '性别',
            married: '婚姻状况',
            cardType: '证件类型',
            card: '证件号码',
            phone: '手机号码',
            code: '验证码',
            inputCode: '请输入验证码',
            getCode: '获取验证码',
            inputPhone: '请输入手机号',
            birthday: '出生日期',
            relation: 'ta是您的',
            inputName: '请输入姓名',
            single: '未婚',
            beMarried: '已婚',
            chooseType: '请选择证件类型',
            inputcard: '请输入证件号码,X为大写',
            chooseTime: '选择日期',
            errMsg: {
                phone: '请填写手机号',
                okPhone: '请填写正确的手机号',
                code: '请填写验证码',
                existPhone: '手机号已存在'
            }
        }
    },
    staffMealDetail: {
        brankNav: '体检服务> 预约体检 > 填写预约信息 > 套餐详情',
        meal: '套餐',
        mealNum1: '此套餐含有',
        mealNum2: '项',
        mealNum3: '检查项',
        medicalItems: '体检项目',
        checkItems: '检查内容',
        examinationSignificance: '检查意义'
    },
    staffHosDetail: {
        brankNav: '体检服务> 预约体检 > 填写预约信息 > 机构详情',
        hos: '机构',
        address: '机构地址',
        time: '营业时间',
        phone: '联系电话',
        msg: '分院简介',
        line: '交通路线'
    },
    staffPhyAckOrder: {
        brankNav: '体检服务> ',
        brankNav2: '体检 > 填写预约信息 > 订单确认',
        consigneeTit: '收货信息',
        consigneeName: '收货人姓名',
        consigneePhone: '收货人手机号',
        consigneeAddress: '收货人地址',
        brankNav3: '体检>',
        brankNav4: '填写预约信息>',
        brankNav5: '订单确认',
    },
    staffSuccess: {
        brankNav: '体检服务 > ',
        brankNav2: '体检 > 填写预约信息 > 订单确认 > 体检预约成功',
        tit: '体检预约成功，请您按时体检',
        getOrder: '查看订单',
        tips: '体检温馨提示',
        front: '检前',
        middle: '检中',
        after: '检后',
        brankNav3: '体检 >',
        brankNav4: '填写预约信息 >',
        brankNav5: '订单确认 >',
        brankNav6: '体检预约成功',
        frontMsg: [
            '(1) 体检前一天请您清淡饮食，勿饮酒、勿劳累。体检当天请空腹，禁食、勿饮水，不要吃对肝、肾功能有损害的药物(降压药、降糖药除外)。',
            '(2) 体检前一天要注意休息，避免剧烈运动和情绪激动，保证充足睡眠，以免影响体检结果。最好能洗个澡。',
            '(3) 女性客人体检请避开月经期。 不要穿花色内衣、带金属扣内衣、不要佩戴首饰，以免影响放射检查。',
        ],
        middleMsg: [
            '(1) 怀孕及准备受孕的女性请预先告知医护人员，我们将不安排您做放射检查。',
            '(2) 做放射线检查前，请您除去身上佩戴的金银、玉器等饰物。',
            '(3) 需空腹检查的项目为抽血、腹部B超、 呼吸实验。内科检查前请您先测量血压。',
            '(4) 女性客人做盆腔B超检查前一小时，请您到餐饮区饮水6-8杯（400-500毫升），使膀胱充盈，以保证检查结果的准确。',





        ],
        middleMsg4: [
            '一般需空腹检查的项目是抽血、腹部B超、呼气实验等，具体可咨询导检人员是否可以就餐。',
            '内科检查前需要先进行一般检查检测血压。',
            '放射线检查须除去身上佩戴的金银、玉器等饰物，以免影响检查结果。',
        ],
        middleMsg5: [
            '5. 女性同学做盆腔B超（腹式）检查前需饮水400-500毫升，使膀胱充盈，以确保检查结果准确 。',
        ],
        afterMsg: [
            '(1)全部检查项目完毕后请您务必将导检订单交到前台。',
            '(2)请您认真听取医生的建议，及时复查。随诊或进一步检查治疗。',
            '(3)《体检报告》默认为电子版，如需纸质版请自行告知前台，医院报告默认为纸质版。',
            '(4)请您保存好体检结果，以便和下次体检结果作对照，也可作为您就医时的资料。'

        ],
        afterMsg2: [
            '民营机构（爱康、慈铭、瑞慈等）的体检报告默认为电子版，可在授权后通过此平台查看并下载，如未授权可凭短信地址到体检机构网站查看，纸质版需主动告知前台自取或快递邮寄。',
            '公立医院的体检报告均为纸质版，请在预约阶段登记本人接收地址，体检报告出具后将安排快递邮寄。',
        ],
        afterMsg3: [
            '3. 请妥善保存体检结果，以便与下次体检进行对照，也可作为就医的资料。',
        ]
    },
    dependentsMsg: {
        brankNav: '体检服务> 家属体检 > 填写预约信息',
        changeDep: '请选择家属',
        addDepend: '添加家属'
    },
    dependentsPhyAckOrder: {
        brankNav: '体检服务> 预约体检 > 填写预约信息 > 订单确认',
        okPay: '确认并购买'
    },
    dependentsPaySuccess: {
        brankNav: '体检服务> 家属体检 > 填写预约信息 > 订单确认 > 体检购买成功',
        tit: '家属体检购买成功',
        nextSubscribe: '下次预约'
    },
    dependentsSuccess: {
        brankNav: '体检服务> 家属体检 > 填写预约信息 > 订单确认 > 体检购买成功 > 家属体检预约 > 体检预约成功',
        tit: '体检预约成功，请提醒家属按时体检'
    },
    dependentsSubscribe: {
        brankNav: '体检服务> 家属体检 > 填写预约信息 > 订单确认 > 体检购买成功 > 家属体检预约',
        error: {
            city: '请选择体检城市',
        }
    },
    person: {
        brankNav: '个人中心',
        staffFilesTit: '个人信息档案',
        phyExam: '体检成员',
        addPhy: '添加体检人',
        healthFilesTit: '健康档案',
        myService: '我的服务',
        waresOrder: '商品订单',
        address: '地址管理',
        insure: '保险订单',
        settings: '设置',
        changePass: '修改密码',
        oldPassword: '请输入原密码',
        newPassword: '请输入新密码',
        newPasswordAgin: '请再次输入新密码',
        passwordAtypism: '两次输入的新密码不一致',
        changePassSuccess: '修改密码成功',
        editPhy: '编辑体检人',
        deletePhy: '删除体检人',
        getDetails: '查看额度详情',
        isDelete: '确认删除该体检人？',
        bdPhone: '请先绑定您的手机号',
        editError: {
            name: '请填写体检人姓名',
            type: '请选择体检人证件类型',
            card: '请填写体检人证件号码',
            phone: '请填写体检人手机号码',
            okPhone: '请填写正确的手机号码',
            okCard: '请填写正确的身份证号',
            birth: '请选择出生日期'
        },
        editSuccess: '修改体检人信息成功',
        deleteSuccess: '删除体检人成功',
        addSuccess: '添加体检人成功'
    },
    integralDetails: {
        brankNav: '个人中心 > 额度使用明细',
        projectName: '项目名称',
        surplusAmount: '剩余额度',
        noRecord: '暂无额度使用记录'
    },
    accountSecurity: {
        brankNav: '个人中心 > 账户安全',
    },
    medicalReports: {
        getInterpret: '查看已约解读',
        interpretListTit: '预约报告解读-已预约',
        creatDate: '创建日期',
        creatName: '姓名',
        creatPhone: '手机号码',
        creatTime: '预约日期',
        writeInterpret: {
            tit: '预约报告解读',
            name: '姓名',
            inputName: '请输入姓名',
            phone: '手机号码',
            inputPhone: '请输入手机号码',
            successPhone: '请输入正确的手机号码',
            time: '预约时段',
            inputTime: '请选择时间段',
            successMsg: '提交成功'
        },
        hint: '温馨提示：解读时间为工作日9:00-18:00',
        brankNav: '体检服务 > 体检报告',
        reportNavList: ['全部报告', '本人'],
        phyPerson: '体检人',
        details: '详情',
        time: '报告时间',
        handle: '操作',
        downloadReport: '下载体检报告',
        decode: '体检报告解读',
        noReport: '暂无体检报告',
        phoneDecode: '电话报告解读',
        onlineDecode: '在线报告解读',
        titOne: '请填写相关体检报告的疑问与异常指标',
        titTwo: '请填写手机号和方便通话的时间段',
        egOne: '例如：尿蛋白偏高，甘油三酯偏高…血红蛋白异常',
        egTwo: '示例：李先生  13562356223  2019年11月11日上午9:00-11:00或下午16:00-18:00',
        error: {
            msg: '请填写您报告的疑问',
            minMsg: '您报告的疑问不能低于20个字符',
            phone: '请填写您的联系方式以及方便通话时间段'
        },
        success: '提交电话解读信息成功',
        addReportBtn: '上传体检报告',
        selfUpload: '自主上传',
        getReport: '查看体检报告',
        uploadNewReport: '上传新体检报告',
        choosePhyPerson: '请选择体检人',
        choosePhyTime: '请选择体检时间',
        chooseFile: '请选择文件',
        uploadFileTit: '请上传相关体检报告及检查资料',
        uploadFileBtn: '点击上传',
        format: '仅支持.JPG/.JPEG/.PNG/.PDF格式',
        uploadSuccess: '上传成功',
        fileNum: '上传图片数量不超过9张'
    },
    myorder: {
        allOrder: '全部订单',
        obligation: '待付款',
        waitingFor: '待体检',
        hasBeen: '已到检'
    },
    loginNew: {
        userNamePrompt: '身份证、护照、港澳台胞证等公司预留证件号',
        welcomeText: '欢迎进入员工体检健康平台',
        loginText: '提高健康状况和职场生活质量'
    },
    phyExServices: {
        staffPhyModel: '本人体检',
        dependPhyModel: '家属体检',
        medicalReportsModel: '体检报告',
        satisfactionFeedback: '满意度反馈',
        physicalNotice: '体检须知',
        name: "姓名",
        sex: '性别',
        cardType: '证件类型',
        idNumber: '证件号码',
        phoneNumber: '手机号码',
        getCode: '获取验证码',
        verificationNumber: "验证号码",
        next: '确认，下一步',
        msg1: '请确认员工信息',
        bindInput1: '请输入性别'
    },
    setingsPage: {
        setingsNav: '个人中心 > 设置',
        bindPhone: '绑定手机号：',
        edit: '修改',
        resetPwd: '更改密码：',
        resetPwdTxt: '更改密码',
        getCode: '获取验证码',
        verificationNumber: '验证号码',
        confirmSave: '确认并保存',
        oldPwd: '原密码',
        newPwd: '新密码',
        confirmPwd: '确认密码',
        bindNumber: "绑定手机号",
        bindInput1: '请输入手机号',
        bindInput2: '请输入验证码',
        bindInput3: '重置密码',
        bindInput4: '请输入原密码',
        bindInput5: '请输入新密码',
        bindInput6: '请再次输入新密码',
        bindInput7: '请为账户绑定您的手机号',
    },
    medicalReports1: {
        deleteReport: '删除体检报告',
        doubt: '您的疑问:',
        cancelReservation: '取消预约',
        interpreted: '已解读',
        cancelled: '已取消',
        customerNumber: '客服电话：400-068-5099 转1 转5566',
        text1: '请详细填写您对体检报告的疑问，以便专家提供更好的解读服务'
    },
    onlineConsulting1: {
        jczq: '健康检查之前：',
        msg1: 'Q：检查前应少吃、多运动，检查数据才会比较标准？',
        msg2: 'A：NO，接受健康检查应以平常心面对，检查前若刻意节食、增加运动，所得的数据反而无法显示身体的真正状况。',
        msg3: 'Q：检查前不必禁食8-12小时之久，吃点东西影响不大？',
        msg4: 'A：NO，在进食后，食物中的不同成分对检查检验结果产生不同程度的影响。进食后，胆囊收缩，在超声检查、肺部CT时会影响显影，而容易遗漏病变。检查前进食还会影响血糖、血脂肪、肝功能及腹部等项目的检测数据，因此检查前至少要禁食8-12小时。',
        msg5: 'Q：检查前数日，必须开始禁吃动物血和肉类，以免影响粪便检查？',
        msg6: 'A：NO，粪便（免疫凝集法）只对人血反应，并不受肉类或动物血的干扰，所以不必禁食。过去会有禁食动物血和肉类的说法，是因为传统的化学检查法，常因受检者在检查前吃了动物血和肉类，因而造成粪便潜血的阳性反应，有鉴于此，爱康特别选择了敏感度高、特异性佳、采样方便的（免疫凝集法），此法只对人血反应，并不受肉类或动物血的干扰。',
        msg7: 'Q：检查前必须中断服药，否则检验结果会受影响？ ',
        msg8: 'A：NO，慢性病患者在接受健康检查前，仍应继续服用药物，不须中断，其检验数据可作为医生的用药参考。',
    },
    orderList: {
        orderStatus: '订单状态：',
        cityName: '体检城市:',
        branchName: '机构分院:',
        branchDetail: '查看分院详情',
        score: '评分',
        fen: '分',
        time: '体检时间',
        routineItems: '常规项目:',
        packageDetails: '查看体检套餐详情',
        totalMoney: '总项目金额：',
        deduction: '加项包额度抵扣：',
        payMoney: '实际支付金额：',
        unauthorized: '未授权',
        qtGetReport: '前台咨询获取纸质报告',
        or: '或',
        reauthorization: '重新授权',
        lookMsg: '已授权-检后7-10个工作日在线查看电子报告',
        lookMsg1: '该分院不支持在本平台查看体检报告，报告获取方式请在体检结束后向前台咨询',
        mailReportMsg: '该分院需邮寄体检报告',
        addressPeople: '收件人：',
        contactNumber: '联系电话：',
        address: '收件地址：',
        ysMsg: '因体检报告为个人隐私，本平台暂无法提供家属体检报告查询功能。您可在体检结束后，关注体检机构发送的短信通知，按操作查看体检报告；如需纸质版报告，请在体检结束后和前台说明领取需求，感谢您的理解与支持！',
        selsectTime: '选择体检时间',
        today: '今日',
        activeDay: '已选',
        adequate: '充足',
        yu: '余',
        wei: '位',
        nervous: '紧张',
        surplus: "无剩余",
        branch: '体检机构：',
        timer: '体检时间：',
        reportStatusMsg: '报告状态：未授权-前台咨询获取纸质报告',
        reportStatusMsg2: '报告状态：已授权-检后7-10个工作日在线查看电子报告',
        reportStatusMsg3: '报告状态：该分院不支持在本平台查看体检报告，报告获取方式请在体检结束后向前台咨询',
        reportStatusMsg4: '报告状态：该分院需邮寄体检报告',
        reportStatusMsg5: '报告状态：本平台暂无法提供家属体检报告查询功能'
    },
    errorAppointment: {
        brendNav: '健康管理 > 预约体检 > 填写预约信息 > 订单确认 > 体检预约失败',
        payError: '体检预约失败！',
        backMoney: '您的体检权益已退回您的账户',
        msg1: '若存在自付费用将自动在1-3个工作日原路退回您的支付账户',
        msg2: '如有疑问，请咨询 4000685099-1-5566',
        fail: '失败原因：',
        checkOrder: '查看订单',
        reschedule: '重新预约',
        brendNav1: '健康管理 >',
        brendNav2: '预约体检 >',
        brendNav3: '填写预约信息 >',
        brendNav4: '订单确认 >',
        brendNav5: '体检预约失败',

    },
    middlePage: {
        msg: '体检预约中，请稍后'
    },
    phyAckOrder: {
        package: "加项包",
        quota: '剩余额度：',
        msg1: '未授权 - 前台咨询获取纸质报告或',
        reauthorization: '重新授权',
        msg2: '因体检报告为个人隐私，本平台暂无法提供家属体检报告查询功能。您可在体检结束后，关注体检机构发送的短信通知，按操作查看体检报告；如需纸质版报告，请在体检结束后和前台说明领取需求，感谢您的理解与支持！'
    },
    writeSubscribe: {
        grade: '评分',
        part: '分',
        distance: '距离:',
        detail: '详情',
        msg1: '选择体检套餐：',
        msg2: '需自费',
        msg3: '总价',
        msg4: '健康问卷：',
        msg5: '未测评',
        msg6: '开始测评',
        msg7: '已测评',
        msg8: '查看测评结果',
        msg9: '重新测评',
        msg10: '选择加项包：',
        msg11: '加项包：',
        msg12: '可用加项包额度：¥',
        msg13: '（请一次性使用，可自由选择以下加项，超出部分需自费，如有剩余不可折现）',
        msg14: '智能推荐',
        msg15: '推荐依据：',
        msg16: '结合您的历史体检报告及问卷调查结果分析，综合大数据医学评估，为您推荐以下适合您的检查加项，可根据您的需求进行选择！',
        msg17: '历史选择',
        msg18: '其他加项',
        msg19: '查看',
        msg20: '购买须知：',
        msg21: '若体检时自费加项项目未做，请于当日内在体检中心前台联系客服：400-068-5099 转1 转5566 办理加项包退费，延期/主动放弃则无法退费，敬请理解。',
        msg22: '选择体检时间：',
        msg23: '体检时间：',
        msg24: '请先选择体检套餐',
        msg25: '尊敬的客户，您好！',
        msg26: '因体检报告为个人隐私，本平台暂无法提供',
        msg27: '家属体检报告',
        msg28: '查询功能。您可在体检结束后，关注体检机构发送的短信通知，按操作查看体检报告；如需纸质版报告，请在体检结束后和前台说明领取需求，感谢您的理解与支持！',
        msg29: '所选加项',
        msg30: '因体检报告为个人隐私，本平台暂无法提供',
        msg31: '加项包额度抵扣',
        msg32: '剩余额度',
        msg33: '已选',
        msg34: '个加项包',
        msg35: '需自费：',
        msg36: '授权本平台查看体检报告说明',
        msg37: '选择体检机构及分院：',
        selsectTime: '选择体检时间',
        hint: '温馨提示：下月排期会在本月15日开放，如需预约公立医院，请及时关注排期开放情况。'
    },
    questionnaire: {
        assessName: '健康测评',
        HealthAssessmentDetail: '参与健康测评，帮助您更快选择加项，合理选择项目，避免过度体检。',
        skipQuestion: "跳过健康测评",
        correct: '是',
        deny: '否',
        nextBtn: '下一题',
        prevBtn: '上一题',
        submitBtn: '提交',
        closeBtn: '关闭',
        evaluationResults: '健康测评结果',
        question1: {
            title: '请输入您的身高及体重：',
            height: "身高(cm)：",
            weight: '体重(kg)：',
            promptText: '您的体脂率（BMI）指标：',
            promptText2: '您的体脂率（BMI）属于',
            thin: '偏瘦',
            normalCategory: '正常范畴',
            overweight: '超重',
            nextQuestion: '请进行下一题',
            saveBtn: '确定',
            question101: '您是否有心悸',
            question102: '您是否有慢性腹泻',
            question103: '您是否有心脑血管疾病家族史（高血压病、心肌梗塞、脑梗塞、脑出血等）',
            question104: '是否打鼾',
            question105: '男：腰围是否大于90；女：腰围是否大于85',
        },
        question2: {
            question201: '你是否有如下情况（一种及以上）：久坐、长期伏案、运动不足'
        },
        question3: {
            question301: '你是否有如下情况（一种及以上）：颈项不适、头晕、手麻'
        },
        question4: {
            question401: '是否腰部不适或腰腿痛？'
        },
        question5: {
            question501: '是否吸烟？',
            question502: '您吸烟数量是否大于20支/天？',
            question503: '请选择您的吸烟史？',
            smokingHistory1: '吸烟史 ＜ 3年',
            smokingHistory2: '3年 ≤ 吸烟史 ≤ 5年',
            smokingHistory3: '吸烟史 ＞ 5年',
        },
        question6: {
            question601: '您是否熬夜或睡眠不足（即：12点以后入睡，总睡眠时间不足6小时）？',
            question602: '您是否有以下症状（可多选）？',
            check1: '疲惫、失眠',
            check2: '易感冒、免疫力差',
            check3: '没有以上症状'
        },
        question7: {
            question701: '是否长期吃外卖且饮食不规律？',
            question702: '是否有以下症状？',
            check1: '腹胀/胃部不适/口臭/大便不成型',
            check2: '女性乳腺增生/男性乳腺发育',
            check3: '没有以上症状'
        },
        question8: {
            question801: '是否有肿瘤家族史（包括父母、爷爷奶奶、外公外婆、父母的兄弟姐妹）？',
            question802: '是否有乳腺癌家族史？',
            question803: '是否有以下情况（多选）？',
            check1: '肿瘤饮食（经常吃烧烤，腌制品，隔夜菜，变质过期食品）',
            check2: '肿瘤环境（辐射如新装修，pm2.5超标，氡超标，电磁辐射如高压线，变压器附近，长期使用微波炉，电磁炉等）',
            check3: '肿瘤性格（指那种情绪受压抑的抑郁性格,表现为害怕竞争,逆来顺受,有气往肚子里咽,爱生闷气的性格）',
            check4: '没有以上症状'
        },
        question9: {
            question901: '有既往甲状腺疾病史（如甲状腺结节、甲亢、甲减、桥本式甲状腺炎等）？',
            question902: '你是否有如下情况（一种及以上）：心悸、消瘦、急躁、女性月经不规律'
        },
        question10: {
            question1001: '是否有乙肝接触史？',
            question1002: '是否接种过乙肝疫苗？'
        },
        question11: {
            question1101: '是否鼻咽部不适或鼻咽癌家族史？',
        },
        finishPage: {
            helloText: '尊敬的用户，您好！',
            riskKeyText: '根据你的问卷填答及健康体检大数据，你可能需要关注的健康事项如下：',
            riskFree: '根据你的问卷结果暂时未发现健康风险问题，继续保持哦！',
            disease: {
                disease1: '甲状腺疾病',
                disease2: '颈椎病变',
                disease3: '菌群失调',
                disease4: '腰椎病变',
                disease5: '心脑血管病',
                disease6: '肺部结节',
                disease7: 'H型高血压',
                disease8: '荷尔蒙失调',
                disease9: '免疫失调',
                disease10: '肾上腺功能失调',
                disease11: '肿瘤风险',
                disease12: '环境荷尔蒙超标',
                disease13: '骨质疏松',
                disease14: '乙肝病毒感染',
                disease15: '鼻咽部疾病',
                disease16: '消化道疾病',
                disease17: '睡眠呼吸暂停低通气综合征',
                title1: '身体内菌群的失调对健康有很大的影响',
                title2: '为伴有高同型半胱氨酸血症的原发性高血压',
                title3: '是体内激素内分泌失调。如某种原因引起的某种激素过多或者是过少，这就造成了内分泌失调（荷尔蒙失调），而引起相应的临床表现',
                title4: '肾上腺是人体重要的内分泌器官，分泌许多种类固醇激素，维持人体的基本生命活动。肾上腺功能失调，不能分泌足够的类固醇激素，从而导致肾上腺疲劳',
                title5: '免疫是机体的一种排斥反应。免疫失调会引起许多疾病，包括变态反应（过敏、风湿类风湿、桥本氏甲状腺炎等）等',
                title6: '即环境激素超标，是指由具有类似雌激素的作用的一类有害化学物质导致人体的性激素分泌量及活性下降，影响人的免疫系统和神经系统，引发健康问题'
            },
            assessmentText: '如想评估上述健康事项，你可以选择增加以下体检项目：',
            notCoveredText: '本次体检未涵盖的检查项',
            intelligenceText: '通过互联网健康大数据，为您推荐如下检查项：',
            referenceOnlyText: '以上内容仅供参考，不作为医疗诊断或诊断意见',
        }
    }
}


// WEBPACK FOOTER //
// ./src/languages/lang/zh.js